import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { enidConfig } from "./data";

export default function EnidPage() {
  return <CityPageTemplate config={enidConfig} />;
}